// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Material Design
import { MatSelectModule } from '@angular/material/select';

// Afidium
import { FormFieldModule } from '../form-field/form-field.module';

import { MultiComboboxComponent } from './multi-combobox.component';
import { TextModule } from '../text/text.module';

@NgModule({
    declarations: [
        MultiComboboxComponent,
    ],
    imports: [
        CommonModule,
        FormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        TextModule,
        //TODO NG UPGRADE MatPseudoCheckboxModule ?
        //MatPseudoCheckboxModule,
    ],
    exports: [
        MultiComboboxComponent,
    ],
    providers: [],
})
export class MultiComboboxModule {}
